import { render, staticRenderFns } from "./VipExclusive.vue?vue&type=template&id=3029f6e8&scoped=true&"
import script from "./VipExclusive.vue?vue&type=script&lang=ts&"
export * from "./VipExclusive.vue?vue&type=script&lang=ts&"
import style0 from "./VipExclusive.vue?vue&type=style&index=0&id=3029f6e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3029f6e8",
  null
  
)

export default component.exports